/*
*   List of Action IDs that should be passed from accreditation.reducer.js to document.reducer.js
 */

export const IDS = {
    /* module */
    accTasks: 'accTasks',

    /* components: */
    accTasksGrid:      'accTasksGrid',
    accTasksDetails:   'accTasksDetails',
    rcoEvidenceGroupDocumentsGrid: 'rcoEvidenceGroupDocumentsGrid',

    /* paths: */
    // tasksDetails:                    'documentDetails',
    // documentReviewsGrid:             'documentReviewsGrid',

    /* tab states: */
    app_accreditation_tasks:          'app.accreditation.tasks',
    app_accreditation_tasks_list:     'app.accreditation.tasks.list',
    app_accreditation_tasks_details:  'app.accreditation.tasks.details',
    // app_accreditation_tasks_add:      'app.accreditation.tasks.add',
};
